import $ from 'jquery';

export const init = () => {

	$(document)
		.on('click', '.js-toggle-animate__link', function() {

			var $this = $(this),
				$generalParent = $('js-toggle-animate'),
				$parent = $this.closest('.js-toggle-animate'),
				$content = $parent.find('.js-toggle-animate__box');

			if ( $parent.hasClass('is-open') ) {
				$content.slideUp(function() {
					$parent.removeClass('is-open');
					$content.removeAttr('style');
				});
			}
			else {
				$content.slideDown(function() {
					$parent.addClass('is-open');
				});
			}


		});
};
